import { useState, useRef, useEffect } from 'react';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import Sidebar from '../../Components/Sideicons/Sidebar';
import "./contact.css";
import { Link } from 'react-router-dom';
import data from "../../Components/country.json";
import { Icon } from '@iconify/react';
import { Helmet } from 'react-helmet';
import { WhatsAppWidget } from 'react-whatsapp-widget';
import ReCAPTCHA from 'react-google-recaptcha';

import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';


const Contact = () => {
  const form = useRef();
  const recaptchaRef = useRef(null);
  const [captchaValue, setCaptchaValue] = useState(null);
  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const [message, setMessage] = useState("");
  const [userName, setUserName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [select, setSelect] = useState('');
  const [messageError, setMessageError] = useState("");

  const handleChange = async (event) => {
    event.preventDefault();

    if (!captchaValue) {
      setMessage("Please verify that you are not a robot!");
      return;
    }

    const formData = new FormData(form.current);
    formData.append("g-recaptcha-response", captchaValue);

    try {
      const response = await fetch('https://app.grintechwebagency.com/wp-json/grintechReact/v1/form', {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        setMessage("Thanks for your query, Our Team will Contact you soon!.");
        // Clear the form fields
        setUserName('');
        setPhone('');
        setEmail('');
        setSelect('');
        setMessageError('');
        form.current.reset();
        recaptchaRef.current.reset(); 
      } else {
        setMessage("Oops! Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error('Error:', error);
      setMessage("Oops! Something went wrong. Please try again.");
    }
  };

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage("");
      }, 4000); 

      return () => clearTimeout(timer);
    }
  }, [message]);

  // const handlePhoneChange = (e) => {
  //   const sanitizedValue = e.target.value.replace(/\D/g, ''); 
  //   if (sanitizedValue.length <= 11) {
  //     setPhone(sanitizedValue);
  //   }
  // };

  // const handleInvalidphone = (event) => {
  //   event.target.setCustomValidity('Enter valid phone number');
  // };

  // const handleInputphone = (event) => {
  //   event.target.setCustomValidity('');
  // };

  const handleInvalidname = (event) => {
    event.target.setCustomValidity('Name must be more than 3 characters.');
  };

  const handleInputname = (e) => {
    const value = e.target.value;
    if (value.length >= 3) {
      e.target.setCustomValidity('');
    } else {
      e.target.setCustomValidity('Name must be at least 3 characters long');
    }
    setUserName(value);
  };

  const handleInvalidemail = (event) => {
    event.target.setCustomValidity('Enter Valid Email Address');
  };

  const handleInputemail = (event) => {
    event.target.setCustomValidity('');
  };

  
  const handleInputmessage = (e) => {
    const value = e.target.value;
    if (value.length >= 20) {
      e.target.setCustomValidity('');
    } else {
      e.target.setCustomValidity('Message should be 20 characters long.');
    }
    setMessageError(value);
  };

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Contact GrinTech Web Agency | Get in Touch Today</title>
        <meta name="description" content="Get in touch with GrinTech Web Agency for expert web development, design, and digital solutions. Contact us today to bring your ideas to life!" />
        <link rel='canonical' href='/contact' />
      </Helmet>


      <Header />
      <Sidebar />
      <WhatsAppWidget phoneNumber="8264420387" message="Hello, how can I help you?" companyName="Grintech Web Agency" />
      <section>
        <div className='container contact__back'>
          <div className='row'>
            <div className='col-lg-8 col-md-12 col-sm-12'>
              <div className='contact___form'>
                <form ref={form} onSubmit={handleChange}>
                  <h1 className='text-center mb-3'> <b style={{ fontWeight: "900" }}>Let's discuss your <span style={{ color: "#0078d6" }}>project</span> </b></h1>
                  <div className='row'>
                    <div className="mb-3 col-md-6">
                      <input
                        type="text"
                        className="form-control"
                        aria-describedby="emailHelp"
                        placeholder="First name"
                        name="fullname"
                        id="fullname"
                        value={userName}
                        onInvalid={handleInvalidname}
                        onInput={handleInputname}
                        required
                      />
                    </div>

                    <div className="mb-3 col-md-6">
                      <input
                        type="text"
                        className="form-control"
                        aria-describedby="emailHelp"
                        placeholder="Last name"
                      />
                    </div>


                    <PhoneInput
                      country={'us'}
                      value={phone}
                      enableSearch
                      onChange={(value, country) => {
                        const dialCode = country.dialCode; // 91
                        const numberOnly = value.replace(dialCode, '');
                        const formattedPhone = `+${dialCode}-${numberOnly}`;
                        setPhone(formattedPhone);
                      }}
                      inputProps={{
                        name: 'phone',
                        required: true,
                      }}
                      inputClass="form-control"
                      containerClass="mb-3"
                    />



                    <div className="mb-3 col-12">
                      <input
                        type="email"
                        className="form-control"
                        aria-describedby="emailHelp"
                        placeholder="Email address"
                        name="email"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        onInvalid={handleInvalidemail}
                        onInput={handleInputemail}
                        required
                        pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}"
                      />
                      <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>
                    </div>
                  </div>
                  <select
                    className="form-select mb-3"
                    aria-label="Default select example"
                    name="select"
                    value={select}
                    onChange={(e) => setSelect(e.target.value)}
                    required
                  >
                    <option selected disabled>Looking for...</option>
                    <option value="UI/UX Design">UI/UX Design</option>
                    <option value="Website Redesign">Web Development</option>
                    <option value="Development">Mobile Application</option>
                    <option value="SEO/SMM">SEO/SMM</option>
                  </select>

                  <div className='col-md-12 col-sm-12 mb-3'>
                    <label htmlFor="exampleInputEmail1" className="form-label text-dark">Upload your file (optional) </label>
                    <input size="40" className="wpcf7-form-control wpcf7-file wpcf7-validates-as-required form-control" accept=".pdf,.txt,.doc,.docx" aria-required="true" aria-invalid="false" type="file" name="your-resume" />
                  </div>

                  <div className="mb-3 mt-4">
                    <textarea
                      className="form-control"
                      rows="3"
                      placeholder="Your message here"
                      name="message"
                      id="message"
                      value={messageError}
                      onInput={handleInputmessage}
                      required
                    ></textarea>
                  </div>
                    
                    {/* Google reCAPTCHA */}
                  <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey="6Lcmhv8qAAAAAAct1lIswDMrZtmrKqTMx_yJO0A2" 
                    onChange={handleCaptchaChange}
                  />

                  <button
                    type="submit"
                    className="btn contact__button mt-3"
                    style={{ backgroundColor: "#177a0e", color: "white" }}
                  >
                    Submit
                  </button>
                  {message &&
                  <p className='text-center' style={{ fontSize: "18px", fontWeight:600, color: "#014072" }}> {message} </p> }
                </form>
              </div>
            </div>
            <div className='col-lg-4 col-md-12 col-sm-12'>
              <div className='contact__sidebar'>
                <h2> <b>Hate Filling Out Forms?</b></h2>
                <div className='red__line mb-3'></div>
                <h4>
                  Request a Quote
                </h4>
                <p>
                  <Link className='contact__sidebar_Link' to="mailto:info@grintechwebagency.com">info@grintechwebagency.com</Link>
                </p>
               
                <h4>
                  HR Queries
                </h4>
                <p>
                  <Link className='contact__sidebar_Link' to="mailto:hr@grintechwebagency.com">hr@grintechwebagency.com</Link>
                </p>
              </div>
            </div>
          </div>

          <div className='row'>
            <div className='contact__content'>
              <h2> What do we have for you?</h2>
              <ul>
                <li>Our Business Development Manager will connect with you through the contact details you drop on our website.</li>
                <li>A discussion of the Requirements will be followed by Suggestions on what's Best for your Business.</li>
                <li>Next, we will Commence Executing the Plans and Suggestions prepared previously.
                </li>
              </ul>
              <div className='contact_ceodetail'>
                <span>
                  <i>"The goal of seeing your website on the top of SERPs is what fuels our plans, efforts, and execution."
                  </i>
                  <br /><span>(Founder & CEO)</span>
                </span>
                <br />
                <Link className='contact__sidebar_Link' to="/">https://www.Grintechwebagency.com</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='py-5'>
        <div className='container'>
          <div className='row '>
            <h2 className='text-center'> <b style={{ fontWeight: "900" }}>Let’s Get to <span style={{ color: "#0078d6" }}>'Talkin'</span> </b></h2>
            <div className='blue__line'></div>
          </div>

          <div className='row mt-3 lets_talk'>
            <div className='col-lg-4 col-md-4 col-sm-12 contact__items'>

              <div className='d-flex '>
                <div> <h6 className='fw-bold'>Mail at:</h6>
                  <h6 className=''> Services: <Link to="mailto:aarti@grintechwebagency.com">info@grintechwebagency.com</Link></h6>
                  <h6> HR: <Link to="mailto:mailto:hr@grintechwebagency.com">: hr@grintechwebagency.com</Link></h6>

                </div>
              </div>


            </div>
            <div className='col-lg-4 col-md-4 col-sm-12 contact__items'>

              <p className=''><Icon icon="logos:whatsapp-icon" width="24" height="24" /> <Link to="https://web.whatsapp.com/7888752763">Whatsapp</Link></p>
              <p><Link to="https://www.instagram.com/grintechwebagency/" target="_blank">
                <img className='insta_img' src='/img/insta.svg' alt='flag' />
                Instagram</Link></p>
            </div>
            <div className='col-lg-4 col-md-4 col-sm-12 contact__items'>
              <p><Icon icon="emojione-v1:flag-for-india" width="24" height="24" /> <a href="tel:+911724643298">(+91) 8264420387</a></p>
            </div>


          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Contact;
